import { render, staticRenderFns } from "./TabelaDadosFiscaisPj.vue?vue&type=template&id=e142754a&lang=pug"
import script from "./TabelaDadosFiscaisPj.vue?vue&type=script&lang=js"
export * from "./TabelaDadosFiscaisPj.vue?vue&type=script&lang=js"
import style0 from "./TabelaDadosFiscaisPj.vue?vue&type=style&index=0&id=e142754a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports